const CommandTypeEnum = {
  ADD_TIME: 'ADD_TIME',
  ADD_SUBMISSION: 'ADD_SUBMISSION',
  PER_QUESTION_SUBMISSION: 'PER_QUESTION_SUBMISSION',
  FLAG_ASSIGNMENT_QUESTION: 'FLAG_ASSIGNMENT_QUESTION',
  CHECK_ANSWER: 'CHECK_ANSWER',
  SET_ASSIGNMENT_START_TIME: 'SET_ASSIGNMENT_START_TIME',
  UNSUBMIT: 'UNSUBMIT',
  RESUBMIT: 'RESUBMIT',
  SET_PROGRESS: 'SET_PROGRESS',
  UPDATE_SCORM: 'UPDATE_SCORM',
  PEER_REVIEW: 'PEER_REVIEW',
  UPDATE_BLOCK_PERFORMANCE: 'UPDATE_BLOCK_PERFORMANCE',
  FORCE_COMPLETE: 'forceComplete',
  RESET_PROGRESS: 'resetProgress',
  EVALUATE_CHECKPOINT: 'EVALUATE_CHECKPOINT',
  ADD_CHECKPOINT_SUBMISSION: 'ADD_CHECKPOINT_SUBMISSION',
  REGISTER_SESSION: 'REGISTER_SESSION',
  UNREGISTER_SESSION: 'UNREGISTER_SESSION',
  REGISTER_SESSIONS: 'REGISTER_SESSIONS',
  UNREGISTER_SESSIONS: 'UNREGISTER_SESSIONS',
  CHANGE_REVIEWER: 'CHANGE_REVIEWER',
  CHANGE_DUE_DATE: 'changeDueDate',
  DEASSIGN_CONTENT: 'deassignContent',
  ASSIGN_CONTENT: 'ASSIGN_CONTENT',
  SUBSCRIBE_FOR_ILT_UPDATES: 'SUBSCRIBE_FOR_ILT_UPDATES'
};

export { CommandTypeEnum };
export default CommandTypeEnum;
